import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'components/Image';
import Link from 'components/Link';
import s from './NriJournalistBanner.scss';

class NriJournalistBanner extends React.PureComponent {
  render() {
    const { theme } = this.props.data;
    const containerClasses = classNames({
      nrljournal_banner: true,
      [s.nrljournal_banner]: true,
      [`${s[theme]}`]: theme,
      [`nri${theme}`]: theme,
    });

    return (
      <div className={containerClasses}>
        <h2>
          {!theme && (
            <>
              <span>click here to apply as</span>
              <>nri citizen journalists</>
            </>
          )}
          {theme === 'thin' && `Be the next NRI citizen journalist`}
        </h2>
        <Link
          href="https://timesofindia.indiatimes.com/application_form.cms#form_nri"
          className={s.btn}
          data-newga={`${this.props.newga}CitizenJournalist_ApplyNow`}
        >
          Apply Now
        </Link>
        {!theme && (
          <>
            <br />
            <a
              href="https://timesofindia.indiatimes.com/nri/citizen-journalists/about_citizen_journalists.cms"
              className={s.know_more}
            >
              Know More
            </a>
          </>
        )}
        <Image
          src="https://static.toiimg.com/photo/71047281.cms"
          alt="banner"
          lazyload
        />
      </div>
    );
  }
}

NriJournalistBanner.propTypes = {
  data: PropTypes.shape({
    theme: PropTypes.string,
  }).isRequired,
  newga: PropTypes.string,
};

NriJournalistBanner.defaultProps = {
  newga: '',
};

export default NriJournalistBanner;
